import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import { ImgixBackground } from 'ha/modules/Image/ImgixBackground';
import { Card, CardActionArea, ImageListItem } from '@hbf/dsl';

import { ImageGridOverlay } from './ImageGridOverlay';
import { ImageGridColContainer } from './ImageGridColContainer';
import { getGridSize } from './helpers';
import { MAX_IMAGES_PER_COL } from './constants';
import { Props as ImageGridProps } from './types';

const useStyles = makeStyles()(theme => ({
  cardStyles: {
    height: '100%',
    width: '100%',
    transform: 'scale(1)',
    transition: 'transform 250ms cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.015)',
    },
  },
  media: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  tile: {
    [theme.breakpoints.down('md')]: {
      // MuiGridListTile-root has an inline style padding
      // This is added to remove
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
    },
  },
}));

interface Props extends ImageGridProps {
  hasSecondCol: boolean;
  autoHeight?: boolean;
}

export const ImageGridCol: React.FC<Props> = ({
  tiles,
  onImageClick,
  hasSecondCol,
  autoHeight = false,
  icon,
}) => {
  const colTiles = tiles.slice(0, 4);
  const { classes, cx } = useStyles();
  const { md } = useMediaQuery();

  return (
    <ImageGridColContainer hasSecondCol={hasSecondCol} autoHeight={autoHeight}>
      {colTiles.map((tile, i) => (
        <ImageListItem
          data-test-locator={`ImageGrid Tile ${tile.id}`}
          key={tile.url}
          onClick={() => onImageClick && onImageClick(tile.id)}
          {...getGridSize(colTiles.length, i)}
          classes={{
            root: classes.tile,
          }}
        >
          {icon && icon}
          <Card square={!md} className={classes.cardStyles}>
            <CardActionArea className={classes.cardStyles}>
              <ImgixBackground
                className={cx(classes.cardStyles, classes.media)}
                src={tile.url}
              />
              {icon ? <ImageGridOverlay showText={false} showGradient /> : null}
              {i === MAX_IMAGES_PER_COL - 1 &&
                tiles.length > MAX_IMAGES_PER_COL && (
                  <ImageGridOverlay tilesLength={tiles.length} />
                )}
            </CardActionArea>
          </Card>
        </ImageListItem>
      ))}
    </ImageGridColContainer>
  );
};
